import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { getArticleSingle, getWorkSingle } from "../api";
import "swiper/css";
import "swiper/css/navigation";
import "../scss/DetailView.scss";
import "../scss/Common.scss";
import "../scss/Swiper.scss";

import { useEffect, useRef, useState } from "react";
import DetailView from "../components/ContentDetail/DetailView";

export default function ArticleDetail() {
  const { articleId } = useParams();

  const articleQuery = useQuery({
    queryKey: ["article", articleId],
    queryFn: getArticleSingle,
  });

  return <DetailView data={articleQuery.data} />;
}
